import React from 'react';
import './TeamGenesis.css';

const TeamGenesis = ({ onBack }) => {
  return (
    <div className="team-genesis-container">
      <header className="team-header">
        <button className="back-button" onClick={onBack}>
          <span className="material-symbols-rounded">arrow_back</span>
          Back to StudySpark
        </button>
        <h1 className="team-title">The Minds Behind Genesis</h1>
      </header>

      <div className="team-content">
        <section className="team-vision">
          <h2>Our Vision</h2>
          <p>
            StudySpark was born out of a simple idea: making revision less of a chore and more of a superpower. 
            We believe that every student deserves access to high-quality, personalized study materials, 
            and we're using the latest AI technology to make that a reality.
          </p>
        </section>

        <div className="team-grid">
          <div className="team-member-card">
            <div className="member-avatar">RG</div>
            <h3>Rushikesh Ghatul</h3>
            <p className="member-role">Core Developer</p>
          </div>
          <div className="team-member-card">
            <div className="member-avatar">AB</div>
            <h3>Akhil Bagal</h3>
            <p className="member-role">UI/UX Designer</p>
          </div>
          <div className="team-member-card">
            <div className="member-avatar">GP</div>
            <h3>Gaurav Pawar</h3>
            <p className="member-role">Backend Engineer</p>
          </div>
          <div className="team-member-card">
            <div className="member-avatar">SS</div>
            <h3>Shivam Salunke</h3>
            <p className="member-role">Product Strategy</p>
          </div>
        </div>

        <section className="team-values">
          <div className="value-item">
            <span className="material-symbols-rounded">bolt</span>
            <h4>Speed</h4>
            <p>Processing complex documents in seconds, not minutes.</p>
          </div>
          <div className="value-item">
            <span className="material-symbols-rounded">verified</span>
            <h4>Quality</h4>
            <p>Ensuring AI-generated content is accurate and relevant.</p>
          </div>
          <div className="value-item">
            <span className="material-symbols-rounded">auto_awesome</span>
            <h4>Simplicity</h4>
            <p>Removing friction from the study process with intuitive UI.</p>
          </div>
        </section>
      </div>

      <footer className="team-footer-discreet">
        <p>&copy; {new Date().getFullYear()} Team Genesis. Built with passion for better learning.</p>
      </footer>
    </div>
  );
};

export default TeamGenesis;
